import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useTargetingClient } from 'jf/services/useTargetingClient';

export const useSyncMessagingUsersQuery = () => {
  const { studyRef } = useParams<{ studyRef: string }>();
  const [nextCursor, setNextCursor] = useState<string>();
  const [enabled, setEnabled] = useState<boolean>(false);
  const [isFinished, setIsFinished] = useState(false);

  const { useSyncUsers } = useTargetingClient();
  const { data, isFetching } = useSyncUsers({
    isEnabled: enabled,
    studyRef,
    cursor: nextCursor,
  });

  // Prefetch the next nextCursor!
  useEffect(() => {
    if (data?.next) {
      setNextCursor(data.next);
    } else {
      setIsFinished(true);
    }
  }, [data]);

  const kickMessagingUsersSync = () => {
    setEnabled(true);
  };

  return { isFinished, slackUsers: data, isFetching, kickMessagingUsersSync, enabled };
};
